import { render, staticRenderFns } from "./AccessControlPermissionsOverview.vue?vue&type=template&id=3985df0a&"
import script from "./AccessControlPermissionsOverview.vue?vue&type=script&lang=js&"
export * from "./AccessControlPermissionsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports